import angular from "angular";
import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";
import GlobalViewUiController from "./GlobalViewUiController";

const GlobalViewUiComponent = {
    name: "tbGlobalViewUi",
    config: {
        template: GlobalViewUiController.template,
        bindings: {},
        controller: GlobalViewUiController,
        controllerAs: GlobalViewUiController.controllerAs
    }
};

export default angular
    .module("trackerbase-app.directives.global-view-ui", DependencyListBuilder([
        GlobalViewUiController.dependencies
    ]))
    .component(GlobalViewUiComponent.name, GlobalViewUiComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/GlobalViewUi/index.js
// module id = c97x
// module chunks = 1